import axios from '../requester';
import { API } from '../constants/api-urls';

export const getReleases = async params =>
  axios.post(`${API.RELEASES_PATH}/search`, params);
